import { render, staticRenderFns } from "./VcitaSelectDropDown.vue?vue&type=template&id=488d22fa&scoped=true"
import script from "./VcitaSelectDropDown.vue?vue&type=script&lang=js"
export * from "./VcitaSelectDropDown.vue?vue&type=script&lang=js"
import style0 from "./VcitaSelectDropDown.vue?vue&type=style&index=0&id=488d22fa&prod&lang=scss&scoped=true"
import style1 from "./VcitaSelectDropDown.vue?vue&type=style&index=1&id=488d22fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488d22fa",
  null
  
)

export default component.exports